import { colors } from '@atlaskit/theme';
import { ReactElement, ReactNode, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components/macro';

import { ROUTE_PATHS } from 'settings';

const Wrapper = styled.div<{ padding: string }>`
  padding: ${({ padding }) => padding};
  background-color: ${colors.N20};
  min-height: calc(100vh - 68px);
`;

interface PageProps {
  children: ReactNode;
}

function Page({ children }: PageProps): ReactElement {
  const { pathname } = useLocation();

  const paddingSetup = useMemo(() => {
    switch (true) {
      case [ROUTE_PATHS.TIME_TRACKING.LOGS.INDEX, ROUTE_PATHS.CALENDAR.INDEX].some((path) =>
        pathname.includes(path),
      ):
        return '0 16px';

      default:
        return '0 16px 55px 16px';
    }
  }, [pathname]);

  return <Wrapper padding={paddingSetup}>{children}</Wrapper>;
}

export default Page;
